import QuoteTripItemsDesktop from "./QuoteTripItems.desktop";

export default QuoteTripItemsDesktop;
